//import './App.css';
import React  from "react";
import  TodoCounter from '../TodoCounter';
import  TodoSearch  from '../TodoSearch';
import  TodoList from '../TodoList';
import  TodoItem  from '../TodoItem';
import  CreateTodoButton from '../CreateTodoButton';
import Modal from '../Modal';
import TodoForm from '../TodoForm';
import { useTodos } from "./useTodos";
import TodosError from '../TodosError';
import TodosLoading from '../TodosLoading';
import EmptyTodos from '../EmptyTodos';
import TodoHeader from '../TodoHeader';
import ChangeAlertwithStorageListener from "../ChargeAlert";

 function App() {
  const {
    error,
    loading,
    searchedTodos,
    completeTodo,
    deleteTodo,
    openModal,
    setOpenModal,
    totalTodos,
    completedTodos,
    searchValue, setSearchValue ,
    addTodo,
    sincronizeTodos

  } = useTodos();
  return (
    <React.Fragment>
{/*       <TodoHeader loading={loading}>
 */}      <TodoCounter 
      totalTodos={totalTodos}
      completedTodos={completedTodos}
      />
       <TodoSearch
      searchValue={searchValue}
       setSearchValue ={setSearchValue}
       loading={loading}
      />
{/* </TodoHeader>
 */}
      <TodoList>

      {error && <TodosError  error={error}/> }
      {loading && <TodosLoading />}
      {(!loading && !searchedTodos.length) && <EmptyTodos />}

        {error && <p>Desespérate, hubo un error...</p>}
        {loading && <p>Estamos cargando, no desesperes...</p>}
        
        {searchedTodos.map(todo => (
          <TodoItem
            key={todo.text}
            text={todo.text}
            completed={todo.completed}
            onComplete={() => completeTodo(todo.text)}
            onDelete={() => deleteTodo(todo.text)}
          />
        ))}
      </TodoList>

      {!!openModal && (
        <Modal>
          <TodoForm 
          addTodo={addTodo}
          setOpenModal={setOpenModal}
          />
        </Modal>
      )}

      <CreateTodoButton
        setOpenModal={setOpenModal}
      />

      <ChangeAlertwithStorageListener
      sincronize={sincronizeTodos}
      />
    </React.Fragment>
  );
  }
export default App;